import { useEffect } from "react";
import Navbar from "./navbar.js";
import Footer from "./footer.js";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Layout({ children }) {
  const handleLineClick = () => {
      if (window._lt) {
        window._lt(
          "send",
          "cv",
          {
            type: "beckertwcom",
          },
          ["2a34ce29-cad2-4b07-a8a0-f386e86ee386"]
        );
      }
    };
  useEffect(() => {
    const backToTopBtn = document.getElementById("backToTop");
    
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        backToTopBtn.style.display = "flex"; // Bootstrap 按鈕用 flex 置中
      } else {
        backToTopBtn.style.display = "none";
      }
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    // 加入事件監聽
    window.addEventListener("scroll", toggleVisibility);
    backToTopBtn.addEventListener("click", scrollToTop);

    // 清理事件，避免記憶體洩漏
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      backToTopBtn.removeEventListener("click", scrollToTop);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/adm")) {
      document.body.classList.remove("frontend");
      document.body.classList.add("backend");
    } else {
      document.body.classList.remove("backend");
      document.body.classList.add("frontend");
    }
  }, [location.pathname]);
  
  return (
    <>
      <Navbar />
      <main>
        {children}
        <div className="customer-service-bar">
          <a
            href="https://page.line.me/vtz1908l?openQrModal=true"
            className="customer-service-btn line"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLineClick}
          >
            <i className="fab fa-line me-2"></i> LINE客服
          </a>

          <Link
            to="./consult"
            className="customer-service-btn assess"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-search me-2"></i> 免費評估
          </Link>

          <Link
            to="./quickbuy"
            className="customer-service-btn buy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-solid fa-cart-shopping me-2"></i> 購買方案
          </Link>
        </div>
        <button
          id="backToTop"
          className="btn rounded-circle"
          title="回到最上方"
        >
          <i class="fa-duotone fa-solid fa-angles-up"></i>
        </button>
      </main>
      <Footer />
    </>
  );
}
